import StoreIcon from '@mui/icons-material/Store';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import AccessKeys from 'common/constants/acces';
import TableViewIcon from '@mui/icons-material/TableView';
export interface INavbarItem {
  link: string;
  section: string;
  iconKey: string;
  text: string;
  module: string;
}

const sidebarNav = [
  {
    link: '/',
    section: 'dashboard',
    // icon: 'lucide:layout-dashboard', //width:"20"
    iconKey: 'dashboard',
    text: 'Dashboard',
  },
  {
    link: '/reports',
    section: 'reports',
    // icon: 'icon-park-outline:transaction-order',
    iconKey: 'reports',
    text: 'Reports',
    module: 'day_report',
  },
  {
    link: '/users',
    section: 'users',
    // icon: 'ph:users-bold',
    iconKey: 'users',
    text: 'Users',
    module: 'user',
  },
  {
    link: '/stores',
    section: 'stores',
    // icon: 'icon-park-outline:transaction-order',
    iconKey: 'stores',
    text: 'Stores',
    module: 'manage_store',
  },
  {
    link: '/royalty',
    section: 'royalty',
    // icon: 'icon-park-outline:transaction-order',
    iconKey: 'royalty',
    text: 'royalty',
    module: 'royalty_report',
    subMenu: [
      {
        link: '/day-report-status',
        section: 'dayReportStatus',
        iconKey: 'reports',
      },
      {
        link: '/royalty',
        section: 'royaltyReports',
        iconKey: 'formResponses',
        text: 'royalty',
        module: 'royalty_report',
      },
    ],
  },
  // {
  //   link: '/analytics',
  //   section: 'analytics',
  //   icon: 'carbon:analytics',
  //   text: 'Analytics',
  // },
  // {
  //   link: '/discount',
  //   section: 'discount',
  //   icon: 'nimbus:discount-circle',
  //   text: 'Discount',
  // },
  // {
  //   link: '/inventory',
  //   section: 'inventory',
  //   icon: 'ic:round-inventory',
  //   text: 'Inventory',
  // },
] as INavbarItem[];

export const getNavIcon = (iconKey: string) => {
  switch (iconKey) {
    case 'dashboard':
      return <DashboardIcon />;
    case 'users':
      return <GroupIcon />;
    case 'stores':
      return <StoreIcon />;
    case 'reports':
      return <AssessmentIcon />;
    case 'royalty':
      return <LocalAtmIcon />;
    case 'reports':
      return <AssessmentIcon />;
    case 'formResponses':
      return <TableViewIcon />;
  }
};

export default sidebarNav;
